import { CheckoutAction } from '../actions/CheckoutAction'
import { SequenceManagerAction } from '../actions/SequenceManagerAction'

const initState = {
    requestBody: {
        sectionId: "paymentMethodAndTermsConditions",
        steps: [
            {
                sequence: "0",
                stepId: "paymentMethod",
                fields: [
                    {
                        name: "PaymentTransactionID",
                        value: ""
                    }
                ],
                options: [
                    {
                        name: "paymentMethod",
                        value: ""
                    }
                ]
            },
            {
                sequence: "0",
                stepId: "termsAndConditions",
                options: [
                    {
                        name: "termsAccepted",
                        value: "true"
                    }
                ]
            }
        ]
    },
    planDetailsResponse : {},
    initiatePaymentResponse : {}
}

const CheckoutReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var CheckoutValue = { ...state.requestBody.steps };

    switch (type) {
        case CheckoutAction.CHECKOUT_PLAN_DETAILS_SUCCESS:
            return {...state, planDetailsResponse: payload}

        case CheckoutAction.INITIATE_PAYMENT_SUCCESS:
            CheckoutValue[0].fields[0].value = payload.data?.data?.refId ? payload.data?.data?.refId : '';
            return { ...state, initiatePaymentResponse: payload }

        case CheckoutAction.HANDLE_CHECKOUT:
            CheckoutValue[0].options[0].value = payload.paymentMethod
            return state;

        case SequenceManagerAction.DISPLAY_PREVIOUS_SECTION:
        case SequenceManagerAction.DISPLAY_SECTION:
            return { ...state, planDetailsResponse: {}, initiatePaymentResponse: {} };

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'paymentMethodAndTermsConditions')
            });
            if (section.length > 0) {
                let paymentType = section[0].steps[0].options[0];
                let refId = section[0].steps[0].fields[0];
                CheckoutValue[0].fields[0].value = refId ? refId.value : "";
                CheckoutValue[0].options[0].value = paymentType ? paymentType.value : "";
            }
            return state;

        default:
            return state;
    }
}

export default CheckoutReducer;